<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M9.41,8C9.41,8,11.7,5.71,11.7,5.71C11.89,5.53,12,5.28,12,5C12,4.45,11.55,4,11,4C10.719999999999999,4,10.469999999999999,4.11,10.29,4.29C10.29,4.29,8,6.59,8,6.59C8,6.59,5.71,4.29,5.71,4.29C5.53,4.11,5.28,4,5,4C4.45,4,4,4.45,4,5C4,5.28,4.11,5.53,4.29,5.71C4.29,5.71,6.59,8,6.59,8C6.59,8,4.3,10.29,4.3,10.29C4.11,10.469999999999999,4,10.719999999999999,4,11C4,11.55,4.45,12,5,12C5.28,12,5.53,11.89,5.71,11.71C5.71,11.71,8,9.41,8,9.41C8,9.41,10.29,11.7,10.29,11.7C10.469999999999999,11.89,10.719999999999999,12,11,12C11.55,12,12,11.55,12,11C12,10.719999999999999,11.89,10.469999999999999,11.71,10.29C11.71,10.29,9.41,8,9.41,8C9.41,8,9.41,8,9.41,8Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SmallCross',
} as DefineComponent
</script>
